import React from 'react'

export default function CommonBlog() {
    return (
        <div className='section-padding bg-[#FDFBF7] 1440:py-[5rem]  999:py-[3.8rem] 768:py-[2.9rem] '>
            <div>
                <h3 className='primary-text font-bold 1440:text-[2.5rem] 1350:text-[2.1rem] 999:text-[1.9rem] text-[1.6rem] text-left'>Lorem ipsum dolor sit amet consectetur. </h3>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Lorem ipsum dolor sit amet consectetur. Feugiat cursus commodo sem morbi. Phasellus massa sed donec et pellentesque. Mauris nibh in ultricies sed porttitor at nulla. Nunc nulla ut ac ac sed fermentum risus ultricies. </p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Netus amet tortor arcu lacinia vitae. Quis quam amet scelerisque augue penatibus eget laoreet id sit.</p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Eget ac est rhoncus dignissim integer id. Felis amet vulputate porta dui amet sit condimentum arcu sem. Egestas quam tellus arcu eget morbi velit amet dictumst. Sem nullam mauris odio tempor odio et adipiscing. Egestas odio aliquam semper urna. At eget in nibh venenatis odio elementum sit venenatis. </p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Nunc duis urna amet nisl adipiscing sed dictum. Nunc ac magna at sem bibendum sagittis. Facilisi facilisis aliquam scelerisque praesent sollicitudin sagittis. Et nunc ac arcu interdum gravida. In at volutpat leo sit nullam lacus mollis egestas quam.</p>
            </div>
            <div>
                <h3 className='primary-text font-bold 1440:text-[2.5rem] 1350:text-[2.1rem] 999:text-[1.9rem] text-[1.6rem] text-left'>Lorem ipsum dolor sit amet consectetur. </h3>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Lorem ipsum dolor sit amet consectetur. Feugiat cursus commodo sem morbi. Phasellus massa sed donec et pellentesque. Mauris nibh in ultricies sed porttitor at nulla. Nunc nulla ut ac ac sed fermentum risus ultricies. </p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Netus amet tortor arcu lacinia vitae. Quis quam amet scelerisque augue penatibus eget laoreet id sit.</p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Eget ac est rhoncus dignissim integer id. Felis amet vulputate porta dui amet sit condimentum arcu sem. Egestas quam tellus arcu eget morbi velit amet dictumst. Sem nullam mauris odio tempor odio et adipiscing. Egestas odio aliquam semper urna. At eget in nibh venenatis odio elementum sit venenatis. </p>
                <p className='text-[1.5rem] primary-text font-light leading-[1.8rem] pt-[0.9rem]'>Nunc duis urna amet nisl adipiscing sed dictum. Nunc ac magna at sem bibendum sagittis. Facilisi facilisis aliquam scelerisque praesent sollicitudin sagittis. Et nunc ac arcu interdum gravida. In at volutpat leo sit nullam lacus mollis egestas quam.</p>
            </div>
            <div className='w-full py-[0.9rem]'>
                <div className='section-primary-bg rounded-[30px] 1550:h-[34.375rem] 1350:h-[29rem] 999:h-[26rem] 600:h-[22rem] h-[60vw] w-full'>

                </div>
            </div>
            <div>
                <h3 className='primary-text font-bold 1440:text-[2.5rem] 1350:text-[2.1rem] 999:text-[1.9rem] text-[1.6rem] text-left'>Lorem ipsum dolor sit amet consectetur. </h3>
                <div>
                    <ul>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Feugiat cursus commodo sem morbi.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Phasellus massa sed donec et pellentesque. Mauris nibh in ultricies sed porttitor at nulla.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Nunc nulla ut ac ac sed fermentum risus ultricies. </p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Netus amet tortor arcu lacinia vitae.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Quis quam amet scelerisque augue penatibus eget laoreet id sit.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Eget ac est rhoncus dignissim integer id.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Felis amet vulputate porta dui amet sit condimentum arcu sem.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Egestas quam tellus arcu eget morbi velit amet dictumst.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Sem nullam mauris odio tempor odio et adipiscing.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>Egestas odio aliquam semper urna.</p>
                            </div>
                        </li>
                        <li>
                            <div className='primary-text flex items-start justify-start gap-[.625rem]'>
                                <div className='bg-[#dd] w-[0.4rem] h-[0.4rem] mt-[9px] rounded-[50%] bg-[#23232D]'>

                                </div>
                                <p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>At eget in nibh venenatis odio elementum sit venenatis. `</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <h3 className='primary-text font-bold 1440:text-[2.5rem] 1350:text-[2.1rem] 999:text-[1.9rem] text-[1.6rem] text-left'>Lorem ipsum dolor sit amet consectetur. </h3>
                <ul>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>1. Lorem ipsum dolor sit amet consectetur.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>2. Feugiat cursus commodo sem morbi.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>3. Phasellus massa sed donec et pellentesque. Mauris nibh in ultricies sed porttitor at nulla.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>4. Nunc nulla ut ac ac sed fermentum risus ultricies. </p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>5. Netus amet tortor arcu lacinia vitae.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>6. Quis quam amet scelerisque augue penatibus eget laoreet id sit.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>7. Eget ac est rhoncus dignissim integer id.</p></li>
                    <li><p className='w-[90%] font-light text-[1.25rem] leading-[29px]'>8. Felis amet vulputate porta dui amet sit condimentum arcu sem.</p></li>
                </ul>
            </div>
            <div>
                <h3 className='primary-text font-bold 1440:text-[2.5rem] 1350:text-[2.1rem] 999:text-[1.9rem] text-[1.6rem] text-left'>Lorem ipsum dolor sit amet consectetur. </h3>
                <p className='w-[90%] font-light text-[1.25rem] leading-[29px] py-[15px]'>1. Lorem ipsum dolor sit amet consectetur.</p>
                <div className='w-full '>
                    <div className='section-primary-bg rounded-[30px] 1550:h-[34.375rem] 1350:h-[29rem] 999:h-[26rem] 600:h-[22rem] h-[60vw] w-full'>

                    </div>
                </div>
                <p className='w-[90%] font-light text-[1.25rem] leading-[29px] py-[15px]'>2. Lorem ipsum dolor sit amet consectetur.</p>
                <div className='w-full '>
                    <div className='section-primary-bg rounded-[30px] 1550:h-[34.375rem] 1350:h-[29rem] 999:h-[26rem] 600:h-[22rem] h-[60vw] w-full'>

                    </div>
                </div>
            </div>
        </div>
    )
}

























